import { render, staticRenderFns } from "./TabConsumo.vue?vue&type=template&id=d92cc0d8&"
import script from "./TabConsumo.vue?vue&type=script&lang=js&"
export * from "./TabConsumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports